import React, { useState } from 'react'
import { Plane, ArrowRight, Loader2, ArrowUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '../ui/Button'
import { mealmateService } from '../../services/mealmateService'
import './MealmateSection.css'

interface TravelModeBannerProps {
  initialMode: boolean
  onToggle: (enabled: boolean) => void
}

const TravelModeBanner: React.FC<TravelModeBannerProps> = ({
  initialMode,
  onToggle
}) => {
  const [enabled, setEnabled] = useState(initialMode)
  const [loading, setLoading] = useState(false)

  const handleToggle = async () => {
    try {
      setLoading(true)
      const newMode = !enabled
      const response = await mealmateService.toggleTravelMode(newMode)
      if (response.success) {
        setEnabled(newMode)
        onToggle(newMode)
      }
    } catch (error) {
      console.error('Failed to toggle travel mode:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={`travel-mode-banner ${enabled ? 'active' : ''}`}>
      <div className="banner-content">
        <div className="banner-info">
          <div className="icon-wrapper">
            <Plane size={24} />
          </div>
          <div>
            <h3>{enabled ? 'Travel Mode Active' : 'Enable Travel Mode?'}</h3>
            <p>
              {enabled 
                ? 'Your nutrition plan is optimized for high-performance travel and partner hospitality.'
                : 'Alert partners and shift your bio-targets for an upcoming trip or flight.'}
            </p>
          </div>
        </div>
        
          <div className="flex items-center gap-3">
            <Link to="/dashboards/travel">
              <Button 
                variant="outline" 
                className="border-white/20 text-white hover:bg-white/10 hidden md:flex"
              >
                Go to Travel OS
                <ArrowUpRight size={16} className="ml-2" />
              </Button>
            </Link>
            
            <Button 
              variant={enabled ? 'outline' : 'default'}
              onClick={handleToggle}
              disabled={loading}
              className={enabled ? 'border-white/30 text-white' : ''}
            >
              {loading ? <Loader2 className="animate-spin" size={18} /> : (
                enabled ? 'Deactivate' : 'Activate Travel Mode'
              )}
            {!loading && <ArrowRight size={18} className="ml-2" />}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default TravelModeBanner
